export const getMemberRole = (userProfile, fallback = "admin") => {
  return userProfile?.memberRole || fallback;
};

export const isTeacherMember = (userProfile, fallback = "admin") => {
  return getMemberRole(userProfile, fallback) === "teacher";
};

export const canManageFinanceMember = (userProfile) => {
  return userProfile?.canManageFinance === true;
};

export const shouldMaskTeacherInfoDesktop = ({
  teacherItem,
  userProfile,
  isTeacherUser,
}) => {
  if (!isTeacherUser) return false;
  if (teacherItem?.id === userProfile?.id || teacherItem?.name === userProfile?.name) return false;
  return teacherItem?.isTeacher === true;
};

export const shouldMaskTeacherInfoMobile = ({
  teacherItem,
  userProfile,
  isTeacherList,
  currentUserUid,
}) => {
  if (getMemberRole(userProfile) === "admin") return false;

  if (!isTeacherList && teacherItem?.isTeacher !== true) return false;

  const profileUid = userProfile?.uid || userProfile?.id || currentUserUid;
  const isMyProfile =
    teacherItem?.id === userProfile?.id ||
    teacherItem?.name === userProfile?.name ||
    teacherItem?.linkedUserId === profileUid;

  if (isMyProfile) return false;

  return true;
};
